import { Navigate, useParams } from 'react-router-dom';
import { slugToCategory } from '@/lib/blogCategories';
import { BLOG_REDIRECTS } from '@/content/blog/redirects';
import BlogCategoryPage from '@/pages/BlogCategory';
import BlogPost from '@/pages/BlogPost';

export default function BlogSlugResolver() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? slugToCategory.get(slug) : undefined;
  const redirect = slug ? BLOG_REDIRECTS[slug] : undefined;

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  if (category) {
    return <BlogCategoryPage category={category} />;
  }

  return <BlogPost />;
}
